import {
  CATALOG_BUSINESS_TYPE,
  CATALOG_BUSINESS_TYPE_CLEAR_DATA,
  CATALOG_BUSINESS_TYPE_ERROR,
  CATALOG_BUSINESS_TYPE_SUCCESS,
  CATALOG_CONSTRUCTION_TYPE,
  CATALOG_CONSTRUCTION_TYPE_CLEAR_DATA,
  CATALOG_CONSTRUCTION_TYPE_ERROR,
  CATALOG_CONSTRUCTION_TYPE_SUCCESS,
  CATALOG_PAYMENT_MODE,
  CATALOG_PLAN_REFERENCE,
  CATALOG_PLAN_REFERENCE_CLEAR_DATA,
  CATALOG_PLAN_REFERENCE_ERROR,
  CATALOG_PLAN_REFERENCE_SUCCESS,
  CATALOG_PAYMENT_MODE_CLEAR_DATA,
  CATALOG_PAYMENT_MODE_ERROR,
  CATALOG_PAYMENT_MODE_SUCCESS,
  GET_CATALOG_ACCOUNT_TYPE,
  GET_CATALOG_ACCOUNT_TYPE_CLEAR_DATA,
  GET_CATALOG_ACCOUNT_TYPE_ERROR,
  GET_CATALOG_ACCOUNT_TYPE_SUCCESS,
  GET_CATALOG_BENEFICIARY,
  GET_CATALOG_BENEFICIARY_CLEAR_DATA,
  GET_CATALOG_BENEFICIARY_ERROR,
  GET_CATALOG_BENEFICIARY_SUCCESS,
  GET_CATALOG_BY_ID,
  GET_CATALOG_BY_ID_CLEAR_DATA,
  GET_CATALOG_BY_ID_ERROR,
  GET_CATALOG_BY_ID_SUCCESS,
  GET_CATALOG_INSURANCE,
  GET_CATALOG_INSURANCE_CLEAR_DATA,
  GET_CATALOG_INSURANCE_ERROR,
  GET_CATALOG_INSURANCE_SUCCESS,
  GET_CATALOG_STATUS_QUOTE,
  GET_CATALOG_STATUS_QUOTE_CLEAR_DATA,
  GET_CATALOG_STATUS_QUOTE_ERROR,
  GET_CATALOG_STATUS_QUOTE_SUCCESS,
  GET_CATALOGS_TYPE,
  GET_CATALOGS_TYPE_CLEAR_DATA,
  GET_CATALOGS_TYPE_ERROR,
  GET_CATALOGS_TYPE_SUCCESS,
  CATALOG_ACTION_TYPE,
  CATALOG_ACTION_TYPE_CLEAR_DATA,
  CATALOG_ACTION_TYPE_ERROR,
  CATALOG_ACTION_TYPE_SUCCESS,
  CATALOG_APPOINTMENT_STATUS,
  CATALOG_APPOINTMENT_STATUS_CLEAR_DATA,
  CATALOG_APPOINTMENT_STATUS_ERROR,
  CATALOG_APPOINTMENT_STATUS_SUCCESS,
} from "./actionTypes";

export const getCatalogById = (getCatalogById, history) => {
  return {
    type: GET_CATALOG_BY_ID,
    payload: { getCatalogById, history },
  };
};

export const getCatalogByIdSuccess = (success) => {
  return {
    type: GET_CATALOG_BY_ID_SUCCESS,
    payload: success,
  };
};

export const getCatalogByIdError = (error) => {
  return {
    type: GET_CATALOG_BY_ID_ERROR,
    payload: error,
  };
};

export const getCatalogByIdClearData = () => {
  return {
    type: GET_CATALOG_BY_ID_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogStatusQuote = (catalogStatusQuote, history) => {
  return {
    type: GET_CATALOG_STATUS_QUOTE,
    payload: { catalogStatusQuote, history },
  };
};

export const getCatalogStatusQuoteSuccess = (success) => {
  return {
    type: GET_CATALOG_STATUS_QUOTE_SUCCESS,
    payload: success,
  };
};

export const getCatalogStatusQuoteError = (error) => {
  return {
    type: GET_CATALOG_STATUS_QUOTE_ERROR,
    payload: error,
  };
};

export const getCatalogStatusQuoteClearData = () => {
  return {
    type: GET_CATALOG_STATUS_QUOTE_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogsType = (catalogsType, history) => {
  return {
    type: GET_CATALOGS_TYPE,
    payload: { catalogsType, history },
  };
};

export const getCatalogsTypeSuccess = (success) => {
  return {
    type: GET_CATALOGS_TYPE_SUCCESS,
    payload: success,
  };
};

export const getCatalogsTypeError = (error) => {
  return {
    type: GET_CATALOGS_TYPE_ERROR,
    payload: error,
  };
};

export const getCatalogsTypeClearData = () => {
  return {
    type: GET_CATALOGS_TYPE_CLEAR_DATA,
    payload: {},
  };
};

///

export const getCatalogPaymentMode = (catalogPaymentMode, history) => {
  return {
    type: CATALOG_PAYMENT_MODE,
    payload: { catalogPaymentMode, history },
  };
};

export const getCatalogPaymentModeSuccess = (success) => {
  return {
    type: CATALOG_PAYMENT_MODE_SUCCESS,
    payload: success,
  };
};

export const getCatalogPaymentModeError = (error) => {
  return {
    type: CATALOG_PAYMENT_MODE_ERROR,
    payload: error,
  };
};

export const getCatalogPaymentModeClearData = () => {
  return {
    type: CATALOG_PAYMENT_MODE_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogAccountType = (catalogAccountType, history) => {
  return {
    type: GET_CATALOG_ACCOUNT_TYPE,
    payload: { catalogAccountType, history },
  };
};

export const getCatalogAccountTypeSuccess = (success) => {
  return {
    type: GET_CATALOG_ACCOUNT_TYPE_SUCCESS,
    payload: success,
  };
};

export const getCatalogAccountTypeError = (error) => {
  return {
    type: GET_CATALOG_ACCOUNT_TYPE_ERROR,
    payload: error,
  };
};

export const getCatalogAccountTypeClearData = () => {
  return {
    type: GET_CATALOG_ACCOUNT_TYPE_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogBeneficiary = (catalogBeneficiary, history) => {
  return {
    type: GET_CATALOG_BENEFICIARY,
    payload: { catalogBeneficiary, history },
  };
};

export const getCatalogBeneficiarySuccess = (success) => {
  return {
    type: GET_CATALOG_BENEFICIARY_SUCCESS,
    payload: success,
  };
};

export const getCatalogBeneficiaryError = (error) => {
  return {
    type: GET_CATALOG_BENEFICIARY_ERROR,
    payload: error,
  };
};

export const getCatalogBeneficiaryClearData = () => {
  return {
    type: GET_CATALOG_BENEFICIARY_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogInsurance = (catalogInsurance, history) => {
  return {
    type: GET_CATALOG_INSURANCE,
    payload: { catalogInsurance, history },
  };
};

export const getCatalogInsuranceSuccess = (success) => {
  return {
    type: GET_CATALOG_INSURANCE_SUCCESS,
    payload: success,
  };
};

export const getCatalogInsuranceError = (error) => {
  return {
    type: GET_CATALOG_INSURANCE_ERROR,
    payload: error,
  };
};

export const getCatalogInsuranceClearData = () => {
  return {
    type: GET_CATALOG_INSURANCE_CLEAR_DATA,
    payload: {},
  };
};

////

export const getCatalogBusiness = (catalogBusiness, history) => {
  return {
    type: CATALOG_BUSINESS_TYPE,
    payload: { catalogBusiness, history },
  };
};

export const getCatalogBusinessSuccess = (success) => {
  return {
    type: CATALOG_BUSINESS_TYPE_SUCCESS,
    payload: success,
  };
};

export const getCatalogBusinessError = (error) => {
  return {
    type: CATALOG_BUSINESS_TYPE_ERROR,
    payload: error,
  };
};

export const getCatalogBusinessClearData = () => {
  return {
    type: CATALOG_BUSINESS_TYPE_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogConstruction = (catalogConstruction, history) => {
  return {
    type: CATALOG_CONSTRUCTION_TYPE,
    payload: { catalogConstruction, history },
  };
};

export const getCatalogConstructionSuccess = (success) => {
  return {
    type: CATALOG_CONSTRUCTION_TYPE_SUCCESS,
    payload: success,
  };
};

export const getCatalogConstructionError = (error) => {
  return {
    type: CATALOG_CONSTRUCTION_TYPE_ERROR,
    payload: error,
  };
};

export const getCatalogConstructionClearData = () => {
  return {
    type: CATALOG_CONSTRUCTION_TYPE_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogPlanReference = (catalogPlanReference, history) => {
  return {
    type: CATALOG_PLAN_REFERENCE,
    payload: { catalogPlanReference, history },
  };
};

export const getCatalogPlanReferenceSuccess = (success) => {
  return {
    type: CATALOG_PLAN_REFERENCE_SUCCESS,
    payload: success,
  };
};

export const getCatalogPlanReferenceError = (error) => {
  return {
    type: CATALOG_PLAN_REFERENCE_ERROR,
    payload: error,
  };
};

export const getCatalogPlanReferenceClearData = () => {
  return {
    type: CATALOG_PLAN_REFERENCE_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogActionType = (catalogActionType, history) => {
  return {
    type: CATALOG_ACTION_TYPE,
    payload: { catalogActionType, history },
  };
};

export const getCatalogActionTypeSuccess = (success) => {
  return {
    type: CATALOG_ACTION_TYPE_SUCCESS,
    payload: success,
  };
};

export const getCatalogActionTypeError = (error) => {
  return {
    type: CATALOG_ACTION_TYPE_ERROR,
    payload: error,
  };
};

export const getCatalogActionTypeClearData = () => {
  return {
    type: CATALOG_ACTION_TYPE_CLEAR_DATA,
    payload: {},
  };
};

export const getCatalogAppointmentStatus = (catalogAppointmentStatus, history) => {
  return {
    type: CATALOG_APPOINTMENT_STATUS,
    payload: { catalogAppointmentStatus, history },
  };
};

export const getCatalogAppointmentStatusSuccess = (success) => {
  return {
    type: CATALOG_APPOINTMENT_STATUS_SUCCESS,
    payload: success,
  };
};

export const getCatalogAppointmentStatusError = (error) => {
  return {
    type: CATALOG_APPOINTMENT_STATUS_ERROR,
    payload: error,
  };
};

export const getCatalogAppointmentStatusClearData = () => {
  return {
    type: CATALOG_APPOINTMENT_STATUS_CLEAR_DATA,
    payload: {},
  };
};
